module.exports = __webpack_public_path__ + "static/media/img34.64200a6a.jpg";